import * as e from "react";
const i = (t) => /* @__PURE__ */ e.createElement("svg", { width: 750, height: 563.15234, viewBox: "0 0 198.43748 149.00072", id: "svg5668", "inkscape:version": "1.2 (dc2aedaf03, 2022-05-15)", "sodipodi:docname": "applewallet.svg", "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape", "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#", "xmlns:cc": "http://creativecommons.org/ns#", "xmlns:dc": "http://purl.org/dc/elements/1.1/", ...t }, /* @__PURE__ */ e.createElement("defs", { id: "defs5662" }, /* @__PURE__ */ e.createElement("linearGradient", { "inkscape:collect": "always", id: "linearGradient4120" }, /* @__PURE__ */ e.createElement("stop", { style: {
  stopColor: "#cbc9be",
  stopOpacity: 1
}, offset: 0, id: "stop4116" }), /* @__PURE__ */ e.createElement("stop", { style: {
  stopColor: "#c8c5bb",
  stopOpacity: 0
}, offset: 1, id: "stop4118" })), /* @__PURE__ */ e.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath3753" }, /* @__PURE__ */ e.createElement("path", { "sodipodi:nodetypes": "sscsscsss", "inkscape:connector-curvature": 0, id: "path3755", d: "m -31.594972,54.69743 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211535 V 85.50908 c 0,-7.873315 3.149738,-14.211536 13.725777,-14.211536 H 122.86692 c 10.57602,0 13.72577,6.338221 13.72577,14.211536 V 68.908965 c 0,-7.873314 -3.14975,-14.211535 -13.72577,-14.211535 z", style: {
  opacity: 1,
  fill: "#4095ca",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
} })), /* @__PURE__ */ e.createElement("filter", { "inkscape:collect": "always", style: {
  colorInterpolationFilters: "sRGB"
}, id: "filter3829", x: -0.047008887, width: 1.0940178, y: -0.27754272, height: 1.5550854 }, /* @__PURE__ */ e.createElement("feGaussianBlur", { "inkscape:collect": "always", stdDeviation: 3.5631452, id: "feGaussianBlur3831" })), /* @__PURE__ */ e.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath3929" }, /* @__PURE__ */ e.createElement("path", { style: {
  opacity: 1,
  fill: "#f16d5e",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
}, d: "m 83.818361,394.03231 c -39.972431,0 -51.876954,23.95549 -51.876954,53.71292 v 7.60641 l 176.408203,0.32617 c 47.12943,0.0873 66.42745,19.0478 86.06641,45.57812 5.00155,6.75662 11.08589,15.9143 17.02733,21.86135 17.74131,17.75789 41.00574,26.62878 64.27148,26.62889 23.26576,1.1e-4 46.53019,-8.87097 64.2715,-26.62889 5.94144,-5.94701 12.02578,-15.10473 17.02735,-21.86135 19.63895,-26.53032 38.93696,-45.49096 86.0664,-45.57812 l 176.40819,-0.32617 v -7.60641 c 0,-29.75743 -11.90453,-53.71292 -51.87692,-53.71292 z", id: "path3931", "inkscape:connector-curvature": 0, "sodipodi:nodetypes": "sscssssssscsss" })), /* @__PURE__ */ e.createElement("filter", { "inkscape:collect": "always", style: {
  colorInterpolationFilters: "sRGB"
}, id: "filter4089", x: -0.053576618, width: 1.1071532, y: -0.071352741, height: 1.1427055 }, /* @__PURE__ */ e.createElement("feGaussianBlur", { "inkscape:collect": "always", stdDeviation: 16.742692, id: "feGaussianBlur4091" })), /* @__PURE__ */ e.createElement("linearGradient", { "inkscape:collect": "always", xlinkHref: "#linearGradient4120", id: "linearGradient4122", x1: -53.582775, y1: 120.72184, x2: -53.582775, y2: 114.41766, gradientUnits: "userSpaceOnUse" }), /* @__PURE__ */ e.createElement("linearGradient", { "inkscape:collect": "always", xlinkHref: "#linearGradient4120", id: "linearGradient4131", gradientUnits: "userSpaceOnUse", x1: -53.582775, y1: 120.72184, x2: -53.582775, y2: 114.41766, gradientTransform: "translate(190.17547)" })), /* @__PURE__ */ e.createElement("sodipodi:namedview", { id: "base", pagecolor: "#ffffff", bordercolor: "#666666", borderopacity: 1, "inkscape:pageopacity": 0, "inkscape:pageshadow": 2, "inkscape:zoom": 0.35, "inkscape:cx": -135.71429, "inkscape:cy": 572.85714, "inkscape:document-units": "mm", "inkscape:current-layer": "g4145", showgrid: "false", "inkscape:snap-smooth-nodes": "true", "inkscape:snap-object-midpoints": "true", showguides: "true", "fit-margin-top": 0, "fit-margin-left": 0, "fit-margin-right": 0, "fit-margin-bottom": 0, "inkscape:window-width": 1620, "inkscape:window-height": 1010, "inkscape:window-x": -6, "inkscape:window-y": -6, "inkscape:window-maximized": 1, "inkscape:guide-bbox": "true", units: "px", "inkscape:object-paths": "true", "inkscape:showpageshadow": 2, "inkscape:pagecheckerboard": "true", "inkscape:deskcolor": "#d1d1d1" }), /* @__PURE__ */ e.createElement("metadata", { id: "metadata5665" }, /* @__PURE__ */ e.createElement("rdf:RDF", null, /* @__PURE__ */ e.createElement("cc:Work", { "rdf:about": "" }, /* @__PURE__ */ e.createElement("dc:format", null, "image/svg+xml"), /* @__PURE__ */ e.createElement("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" })))), /* @__PURE__ */ e.createElement("g", { "inkscape:label": "Layer 1", "inkscape:groupmode": "layer", id: "layer1", transform: "translate(53.582777,-46.342901)" }, /* @__PURE__ */ e.createElement("g", { id: "g5740", transform: "matrix(1,0,0,1.0056496,24.568462,4.937821)", style: {
  fill: "#ff0000",
  fillOpacity: 0,
  strokeWidth: 0.997187
} }, /* @__PURE__ */ e.createElement("path", { "inkscape:connector-curvature": 0, id: "rect5713", d: "m 10.108037,0.24338852 c -36.91084,0 -63.87995,22.39413848 -63.87995,64.79580448 V 198.5445 c 0,42.40171 26.96911,64.79582 63.87995,64.79582 H 146.93146 c 36.91084,0 63.87996,-22.39411 63.87996,-64.79582 V 65.039193 c 0,-42.401691 -26.96912,-64.79580448 -63.87996,-64.79580448 z", style: {
  opacity: 1,
  fill: "#ff0000",
  fillOpacity: 0,
  stroke: "none",
  strokeWidth: 2.09409,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.383178
} })), /* @__PURE__ */ e.createElement("g", { id: "g4145" }, /* @__PURE__ */ e.createElement("path", { "inkscape:connector-curvature": 0, id: "path4095", transform: "matrix(0.26458333,0,0,0.26458333,-53.771913,0.24338852)", d: "m 77.738281,174.23438 c -50.500035,-2e-5 -77.02343725,30.81653 -77.02343725,77.02343 v 409.10547 c 0,46.20688 26.52340225,77.02344 77.02343725,77.02344 H 673.69141 c 50.50004,0 77.02343,-30.81656 77.02343,-77.02344 V 251.25781 c 0,-46.2069 -26.52339,-77.02344 -77.02343,-77.02343 z", style: {
  opacity: 1,
  fill: "#d9d6cc",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 155.717,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }), /* @__PURE__ */ e.createElement("path", { "sodipodi:nodetypes": "sscssssssscsss", "inkscape:connector-curvature": 0, id: "rect3638", d: "m -31.594972,54.697449 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211536 v 51.812855 l 46.6746696,0.0863 c 12.4696614,0.0231 17.5755964,5.03973 22.7717374,12.05921 1.323329,1.78769 2.933142,4.21066 4.50515,5.78415 4.694053,4.69844 10.849433,7.04553 17.005162,7.04556 6.15573,3e-5 12.31111,-2.34711 17.005165,-7.04556 1.572006,-1.57348 3.181821,-3.99646 4.505151,-5.78415 5.196141,-7.01948 10.302073,-12.03615 22.771737,-12.05921 l 46.674667,-0.0863 V 68.908985 c 0,-7.873315 -3.14974,-14.211536 -13.72577,-14.211536 z", style: {
  opacity: 1,
  fill: "#f16d5e",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
} }), /* @__PURE__ */ e.createElement("path", { transform: "matrix(0.26458333,0,0,0.26458333,-53.771913,0.24338852)", "sodipodi:nodetypes": "sscsscsss", "inkscape:connector-curvature": 0, id: "path3676", d: "m 83.818359,205.81055 c -39.97243,0 -51.876953,23.95548 -51.876953,53.71289 v 62.74059 c 0,-29.75741 11.904523,-53.71289 51.876953,-53.71289 H 667.61133 c 39.97239,0 51.87695,23.95548 51.87695,53.71289 v -62.74059 c 0,-29.75741 -11.90456,-53.71289 -51.87695,-53.71289 z", style: {
  opacity: 1,
  fill: "#3295c9",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 68.0315,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
} }), /* @__PURE__ */ e.createElement("path", { clipPath: "url(#clipPath3753)", "sodipodi:nodetypes": "sscsscsss", "inkscape:connector-curvature": 0, id: "path3685", d: "m -31.594972,71.297543 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211536 v 16.600111 c 0,-7.873312 3.149738,-14.211532 13.725777,-14.211532 H 122.86692 c 10.57602,0 13.72577,6.33822 13.72577,14.211532 V 85.509079 c 0,-7.873315 -3.14975,-14.211536 -13.72577,-14.211536 z", style: {
  opacity: 1,
  fill: "#000000",
  fillOpacity: 0.317757,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477,
  filter: "url(#filter3829)"
} }), /* @__PURE__ */ e.createElement("path", { style: {
  opacity: 1,
  fill: "#fcad00",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
}, d: "m -31.594972,71.297544 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211535 v 16.600111 c 0,-7.873311 3.149738,-14.211532 13.725777,-14.211532 H 122.86692 c 10.57602,0 13.72577,6.338221 13.72577,14.211532 V 85.509079 c 0,-7.873314 -3.14975,-14.211535 -13.72577,-14.211535 z", id: "path3833", "inkscape:connector-curvature": 0, "sodipodi:nodetypes": "sscsscsss" }), /* @__PURE__ */ e.createElement("path", { transform: "translate(4.6064453e-7,16.600115)", style: {
  opacity: 1,
  fill: "#000000",
  fillOpacity: 0.313725,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477,
  filter: "url(#filter3829)"
}, d: "m -31.594972,71.297543 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211536 v 16.600111 c 0,-7.873312 3.149738,-14.211532 13.725777,-14.211532 H 122.86692 c 10.57602,0 13.72577,6.33822 13.72577,14.211532 V 85.509079 c 0,-7.873315 -3.14975,-14.211536 -13.72577,-14.211536 z", id: "path3835", "inkscape:connector-curvature": 0, "sodipodi:nodetypes": "sscsscsss", clipPath: "url(#clipPath3753)" }), /* @__PURE__ */ e.createElement("path", { "sodipodi:nodetypes": "sscsscsss", "inkscape:connector-curvature": 0, id: "path3837", d: "m -31.594972,87.897659 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211531 v 16.60012 c 0,-7.87332 3.149738,-14.21154 13.725777,-14.21154 H 122.86692 c 10.57602,0 13.72577,6.33822 13.72577,14.21154 v -16.60012 c 0,-7.87331 -3.14975,-14.211531 -13.72577,-14.211531 z", style: {
  opacity: 1,
  fill: "#50be3d",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
} }), /* @__PURE__ */ e.createElement("path", { clipPath: "url(#clipPath3753)", "sodipodi:nodetypes": "sscsscsss", "inkscape:connector-curvature": 0, id: "path3839", d: "m -31.594972,71.297543 c -10.576039,0 -13.725777,6.338221 -13.725777,14.211536 v 16.600111 c 0,-7.873312 3.149738,-14.211532 13.725777,-14.211532 H 122.86692 c 10.57602,0 13.72577,6.33822 13.72577,14.211532 V 85.509079 c 0,-7.873315 -3.14975,-14.211536 -13.72577,-14.211536 z", style: {
  opacity: 1,
  fill: "#000000",
  fillOpacity: 0.313725,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477,
  filter: "url(#filter3829)"
}, transform: "translate(9.2128905e-7,33.20023)" }), /* @__PURE__ */ e.createElement("path", { clipPath: "url(#clipPath3929)", style: {
  opacity: 1,
  fill: "#f26d5f",
  fillOpacity: 0.29803923,
  stroke: "none",
  strokeWidth: 155.717,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1,
  filter: "url(#filter4089)"
}, d: "m 77.738281,174.23438 c -50.500036,-2e-5 -77.02343725,30.81653 -77.02343725,77.02343 v 409.10547 c 0,46.20688 26.52340125,77.02344 77.02343725,77.02344 H 673.69141 c 50.50004,0 77.02343,-30.81656 77.02343,-77.02344 V 251.25781 c 0,-46.2069 -26.52339,-77.02344 -77.02343,-77.02343 z m 6.080078,31.57617 H 667.61133 c 39.97239,0 51.87695,23.95548 51.87695,53.71289 v 195.82812 l -176.4082,0.32617 c -47.12944,0.0872 -66.42745,19.04781 -86.06641,45.57813 -5.00156,6.75662 -11.0859,15.91432 -17.02734,21.86133 -17.74131,17.75792 -41.00574,26.62902 -64.27149,26.6289 -23.26574,-1.1e-4 -46.53018,-8.87102 -64.27148,-26.6289 -5.94145,-5.94705 -12.02579,-15.10471 -17.02734,-21.86133 -19.63896,-26.53032 -38.93698,-45.49082 -86.06641,-45.57813 L 31.941406,455.35156 V 259.52344 c 0,-29.75741 11.904523,-53.71289 51.876953,-53.71289 z", id: "path3848", "inkscape:connector-curvature": 0, transform: "matrix(0.26458333,0,0,0.26458333,-53.771913,0.24338852)" }), /* @__PURE__ */ e.createElement("path", { "inkscape:connector-curvature": 0, id: "rect4114", d: "m -53.582775,108.55904 h 8.262028 v 12.1628 h -8.262028 z", style: {
  opacity: 1,
  fill: "url(#linearGradient4122)",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
} }), /* @__PURE__ */ e.createElement("path", { style: {
  opacity: 1,
  fill: "url(#linearGradient4131)",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 18,
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 0.607477
}, d: "m 136.59269,108.55904 h 8.26203 v 12.1628 h -8.26203 z", id: "path4129", "inkscape:connector-curvature": 0 }))));
export {
  i as default
};
//# sourceMappingURL=apple-wallet.svg.js.map
